// extracted by mini-css-extract-plugin
export default {"main-content":"PropertyUpload_main-content__aA6H3","main":"PropertyUpload_main__GzWw3","buttons":"PropertyUpload_buttons__lrb1v","refresh":"PropertyUpload_refresh__ajaEJ"};